<template>
  <div class="bg-light p-5 rounded-3">
    <h3>Introduction</h3>
    <p class="lead">
      The technology of Single cell RNA sequencing (scRNA-seq) has undergone significant advancements in recent years, 
      leading to the generation of vast amounts of data. Despite its novelty, there exists a dearth of comprehensive 
      plant-specific databases that can effectively collate and analyze scRNA-seq data.
      To address this gap, we present <b style="color: #41ab5d;">scPlantDB</b>, a newly developed database designed to 
      cater to the specific needs of the plant researchers.
    </p>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>